<template>
    <span
        :class="sizesClass"
        class="inline-block rounded-xl mr-1"
        :style="background"></span>
</template>

<script>
export default {
    props: {
        size: {
            default: 2,
        },
        color: {}
    },
    computed: {
        sizesClass() {
            return `w-${this.size} h-${this.size}`;
        },
        background() {
            return `background-color: ${this.color}`;
        }
    }
}
</script>

<style scoped>

</style>
